import firebase from "firebase";
import "firebase/auth";
import "firebase/storage";

const fb = !firebase.apps.length
  ? firebase.initializeApp({
      apiKey:
        process.env.FIREBASE_APIKEY ||
        "AIzaSyBWQig0oJpR50r1T6zto2fzmU2gRxOjTD0",
      authDomain:
        process.env.FIREBASE_AUTHDOMAIN || "forcatch-5df5d.firebaseapp.com",
      databaseURL:
        process.env.FIREBASE_DATABASEURL ||
        "https://forcatch-5df5d-default-rtdb.europe-west1.firebasedatabase.app/",
      projectId: process.env.FIREBASE_PROJECTID || "forcatch-5df5d",
      storageBucket:
        process.env.FIREBASE_STORAGEBUCKET || "forcatch-5df5d.appspot.com",
      messagingSenderId:
        process.env.FIREBASE_MESSAGINGSENDERID || "670709925922",
    })
  : firebase.app();

export const getAuthInstance = () => {
  return fb.auth();
};

export const login = async (email, password) => {
  await fb.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  const { user } = await fb.auth().signInWithEmailAndPassword(email, password);
  return checkEmailVerified(user);
};

function checkEmailVerified(user) {
  if (user && user.emailVerified) return Promise.resolve(user);
  fb.auth().currentUser.sendEmailVerification();
  return Promise.reject({ code: "auth/email-not-verified" });
}

export const logout = async () => {
  return await fb.auth().signOut();
};

export const getUid = async () => {
  return await fb.auth().currentUser.uid;
};

export const getToken = () => {
  return fb.auth().currentUser.getIdToken(true);
};

export const getNameFromUrl = async (url) => {
  const httpsReference = await fb.storage().refFromURL(url);
  return httpsReference.name;
};

export const isLogged = () => {
  const user = fb.auth().currentUser;
  return user && user.emailVerified;
};

export const addAvatars = async (users) => {
  return await Promise.all(
    users.map(async (user) => {
      let avatar = "";
      try {
        avatar = await getAvatarUrl(user.uid);
      } catch (error) {
        console.log(error);
      }
      return {
        ...user,
        url: avatar,
      };
    })
  );
};
export const createUser = ({
  email,
  password,
  name,
  lang = process.env.DEFAULT_LANG,
}) => {
  fb.auth().languageCode = lang;
  return fb
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then(() => fb.auth().currentUser.updateProfile({ displayName: name }))
    .then(() => fb.auth().currentUser.sendEmailVerification());
};

export const verifyEmail = (code) => {
  return fb.auth().applyActionCode(code);
};

export const sendPasswordResetEmail = (email) => {
  return fb.auth().sendPasswordResetEmail(email);
};

export const confirmPasswordReset = (code, newPassword) => {
  return fb.auth().confirmPasswordReset(code, newPassword);
};

export const formatError = (errorCode) => {
  switch (errorCode) {
    case "auth/user-disabled":
      return "FIREBASE_USER_DISABLED";
    case "auth/user-not-found":
      return "FIREBASE_USER_NOT_FOUND";
    case "auth/wrong-password":
      return "FIREBASE_WRONG_PASSWORD";
    case "auth/email-not-verified":
      return "FIREBASE_EMAIL_NOT_VERIFIED";
    case "auth/invalid-action-code":
    case "auth/expired-action-code":
      return "FIREBASE_INVALID_CODE";
    case "auth/email-already-in-use":
      return "FIREBASE_EMAIL_ALREADY_IN_USE";
    case "auth/weak-password":
      return "FIREBASE_PASSWORD_LENGTH";
    default:
      return "ERROR";
  }
};

const getAvatarStorageRef = (uid) => {
  return fb.storage().ref().child(`avatars/${uid}.jpg`);
};

export const uploadAvatar = (uid, file) => {
  if (!uid || !file) return Promise.resolve();

  return getAvatarStorageRef(uid).put(file);
};

export const getAvatarUrl2 = (uid) => {
  if (!uid) return Promise.resolve("");

  return getAvatarStorageRef(uid)
    .getDownloadURL()
    .catch(() => "");
};

export const getAvatarUrl = async (userId) => {
  try {
    const upload = getAvatarStorageRef(userId);

    // Ottieni la dimensione del file da Firebase Storage
    const metadata = await upload.getMetadata();
    const firebaseSize = metadata.size;
    const localSize = localStorage.getItem(`avatarSize-${userId}`);

    if (firebaseSize === Number(localSize)) {
      console.log("L'immagine esiste già in locale ed è aggiornata.");
      return localStorage.getItem(`avatarUrl-${userId}`);
    }
    const url = await upload.getDownloadURL();
    // Cancella l'immagine locale se esiste
    if (localSize) {
      localStorage.removeItem(`avatarUrl-${userId}`);
    }
    // Scarica l'immagine
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const base64data = reader.result;
        // Salva l'URL dell'immagine e la dimensione nel localStorage
        localStorage.setItem(`avatarUrl-${userId}`, base64data);
        localStorage.setItem(`avatarSize-${userId}`, firebaseSize.toString());
        console.log("Immagine scaricata e salvata in:", base64data);
        resolve(base64data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.log(error);
    return getAvatarUrl2(userId);
  }
};

export const deleteAvatar = (uid) => {
  if (!uid) return Promise.resolve();

  return getAvatarStorageRef(uid).delete();
};

export const uploadFile = (uid, file) => {
  if (!uid || !file) return Promise.resolve();

  const { name = "" } = file;
  const ext = name.split(".").pop();
  const newFileName = `${Date.now()}.${ext}`;

  return fb.storage().ref().child(`${uid}/${newFileName}`).put(file);
};

export const getUploadedFileUrl = (fullPath) => {
  if (!fullPath) return Promise.resolve("");

  return fb
    .storage()
    .ref()
    .child(fullPath)
    .getDownloadURL()
    .catch(() => "");
};

export const deleteFile = (fullPath) => {
  if (!fullPath) return Promise.resolve();

  return fb.storage().ref().child(fullPath).delete();
};

export const getDownloadUrl = (path) => {
  return fb.storage().ref().child(path).getDownloadURL();
};



// WEBPACK FOOTER //
// src/helpers/firebase.js